import { render, staticRenderFns } from "./PartnerPageFooter.vue?vue&type=template&id=6ee3403e&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee3403e",
  null
  
)

export default component.exports